import { withState } from 'recompose';

export interface WidthProps {
    width: number;
    setWidth: (width: number) => void;
}

export default withState('width', 'setWidth', 0);